export default __webpack_public_path__ + "6f552cb9216cde587e8e6c31d89eff7f.png";